export const userElementAuthorization = (
  canKeepAccess,
  creatorSubscriptionPlan
) => {
  if (canKeepAccess || creatorSubscriptionPlan !== 'essential') return true

  return false
}
